var _mask, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1185_12170",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84717 5.44904L0.129662 5.44903L4.48175 -0.00285473L8.84717 5.44904Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84717 5.44904L8.84717 10.8975L20.1897 10.8975L13.1002 2.04356L8.84717 5.44904ZM0.129662 5.44903L-4.12845 2.04991L-11.1912 10.8975L0.129661 10.8975L0.129662 5.44903ZM4.48175 -0.00285473L8.73477 -3.40833L4.47523 -8.72799L0.223637 -3.40198L4.48175 -0.00285473ZM8.84717 0.000594139L0.129662 0.000593377L0.129661 10.8975L8.84717 10.8975L8.84717 0.000594139ZM4.38777 8.84816L8.73985 3.39627L0.223637 -3.40198L-4.12845 2.04991L4.38777 8.84816ZM0.228716 3.40262L4.59414 8.85451L13.1002 2.04356L8.73477 -3.40833L0.228716 3.40262Z",
    fill: "url(#paint0_diamond_1185_12170)",
    mask: "url(#path-1-inside-1_1185_12170)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_1185_12170",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.48841 5.44904) rotate(-180) scale(4.35875 5.45189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.b1094c02dbacd6b8db760b1fb728459d.svg";
export { ForwardRef as ReactComponent };